import React from 'react';
import { useLang } from '@/context/LanguageContext';
import { CANCELLED, formatDay } from '@/data/catalog';
import { AlertTriangle } from 'lucide-react';

// Avisos de última hora del festival (cancelaciones, cambios de programa).
//
// No se escriben aquí: se generan solos a partir de los items marcados con
// "cancelat": true en festivalData.json, con su texto en "avis" (ca/es/fr).
// Si no hay ninguno marcado, este componente no pinta nada y la web queda
// exactamente como estaba. Para retirar un aviso, basta con borrar esas dos
// claves del JSON.
//
// variant="banner" → una línea, para la portada.
// variant="full"   → el comunicado completo, para la agenda.
export const Avis = ({ variant = 'full' }) => {
  const { t, lang } = useLang();

  if (CANCELLED.length === 0) return null;

  if (variant === 'banner') {
    return (
      <div
        data-testid="avis-banner"
        className="rounded-xl border border-[var(--cea-lamp-red)]/45 bg-[var(--cea-lamp-red)]/10 px-4 py-3"
      >
        <div className="flex items-start gap-2.5">
          <AlertTriangle size={17} className="mt-0.5 flex-shrink-0 text-[var(--cea-lamp-red)]" />
          <div className="min-w-0">
            {CANCELLED.map((s) => (
              <p key={s.id} className="text-sm text-white/85">
                <span className="font-bold uppercase tracking-wide text-[var(--cea-lamp-red)]">
                  {t.avis.badge}
                </span>
                <span className="mx-1.5 text-white/30">·</span>
                <span className="font-semibold text-white">{s.titol}</span>
                {s.dia && (
                  <span className="text-white/70">
                    {' '}
                    ({formatDay(s.dia, t.months)}
                    {s.hora ? ` · ${s.hora}` : ''})
                  </span>
                )}
              </p>
            ))}
            <a
              href="#agenda"
              data-testid="avis-banner-link"
              className="mt-1 inline-block text-xs font-bold uppercase tracking-wide text-[var(--cea-accent)] hover:underline"
            >
              {t.hero.ctaAgenda} →
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      data-testid="avis-full"
      className="rounded-2xl border border-[var(--cea-lamp-red)]/45 bg-[var(--cea-lamp-red)]/10 p-5 sm:p-6"
    >
      <div className="flex items-start gap-3">
        <AlertTriangle size={20} className="mt-0.5 flex-shrink-0 text-[var(--cea-lamp-red)]" />
        <div className="min-w-0 space-y-4">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[var(--cea-lamp-red)]">
            {t.avis.heading}
          </p>
          {CANCELLED.map((s) => (
            <div key={s.id}>
              <p className="font-display font-medium text-lg leading-tight tracking-[-0.01em] text-white">
                {s.titol}
                {s.dia && (
                  <span className="ml-2 align-middle text-sm font-sans font-semibold text-white/60">
                    {formatDay(s.dia, t.months)}
                    {s.hora ? ` · ${s.hora}` : ''}
                    {s.ubicacio ? ` · ${s.ubicacio}` : ''}
                  </span>
                )}
              </p>
              {s.avis && (
                <p className="mt-1.5 text-sm sm:text-[15px] leading-relaxed text-white/85">
                  {s.avis[lang]}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
